import React from 'react';
import { Layout, Menu } from 'antd';
import { GithubOutlined } from '@ant-design/icons';

const { Header } = Layout;

const AppHeader = () => {
  return (
    <Header style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between',
      padding: '0 50px'
    }}>
      <div className="logo" style={{ 
        color: '#fff', 
        fontSize: '18px',
        whiteSpace: 'nowrap',
        '@media (min-width: 768px)': {
          fontSize: '24px'
        }
      }}>
        Lifeano APP
      </div>
      <Menu
        theme="dark"
        mode="horizontal"
        defaultSelectedKeys={['1']}
        items={[
          { key: '1', label: '首页' },
          { key: '2', label: '功能介绍' },
          { key: '3', label: '关于我们' },
        ]}
      />
    </Header>
  );
};

export default AppHeader;